import { Box, Button, FormControl, FormControlLabel, Modal, Radio, RadioGroup } from '@mui/material';
import React, { useState } from 'react'
import DeepSearchFormModal from './DeepSearchFormModal';
import CloseIcon from '@mui/icons-material/Close';
const DeepSearchSelectionModal = ({ openSelectionModal, setOpenSelectionModal, setLoading }) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 480,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const [selectedValue, setSelectedValue] = useState("Organization")
    const [openFormModal, setOpenFormModal] = useState(false)
    const [organizationSearch, setOrganizationSearch] = React.useState({
        name: "",
        website: "",
        industry: "",
        linkedInUrl: "",
        country: "",
        address: "",
        city: "",
        state: "",
        limit: 0
    });
    const [prospectSearch, setProspectSearch] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        jobtitle: "",
        organization: "",
        linkedInUrl: "",
        limit: 0
    });
    const handleOrgCancel = () => {
        setOpenSelectionModal(false);
        setOpenFormModal(false);
        setOrganizationSearch({
            name: "",
            website: "",
            industry: "",
            linkedInUrl: "",
            country: "",
            address: "",
            city: "",
            state: "",
            limit: 0
        })
        setProspectSearch({
            firstName: "",
            lastName: "",
            email: "",
            jobtitle: "",
            organization: "",
            linkedInUrl: "",
            limit: 0
        });
        setSelectedValue("Organization")
    }
    return (
        <>
            <Modal
                open={openSelectionModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="advance-search-modal">
                    <Box sx={style} style={{ overflowY: "auto" }}>
                        <div className="de_pad-adv-search">
                            <h3 className='adv-search-modal'>Deep Search<CloseIcon onClick={handleOrgCancel} /></h3>
                            <p className='sub-head-adv-search-mdl'>Please choose an Organization or a Prospect to search for.</p>
                            <div style={{ marginLeft: '10px' }}>
                                <FormControl>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="Organization"
                                        name="radio-buttons-group"
                                        onChange={(e) => setSelectedValue(e?.target?.value)}
                                    >
                                        <FormControlLabel value="Organization" control={<Radio />} label="Organization" />
                                        <FormControlLabel value="Prospect" control={<Radio />} label="Prospect" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => { handleOrgCancel() }} >Cancel</Button>
                                    <Button className='de_next' onClick={() => { setOpenFormModal(true) }}>Next</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
            <DeepSearchFormModal openFormModal={openFormModal} setOpenFormModal={setOpenFormModal} selectedValue={selectedValue}
                setOpenSelectionModal={setOpenSelectionModal}
                organizationSearch={organizationSearch} setOrganizationSearch={setOrganizationSearch}
                prospectSearch={prospectSearch} setProspectSearch={setProspectSearch}
                handleOrgCancel={handleOrgCancel} setLoading={setLoading} />
        </>
    )
}
export default DeepSearchSelectionModal